import { Component, OnInit, ViewChild } from "@angular/core";
import { DataTableDirective } from "angular-datatables";
import { Subject } from "rxjs";
import { Router } from "@angular/router";
import { CommonService } from "../common.service";
import { NgxSpinnerService } from "ngx-spinner";
import { DatePipe } from "@angular/common";
import { StorageService } from "../storage.service";
import { CommonVariablesService } from "./../common-variables.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";

@Component({
	selector: "app-master-policy-complete",
	templateUrl: "./master-policy-complete.component.html",
})
export class MasterPolicyCompleteComponent implements OnInit {
	incompletePolicyForm: FormGroup;
	completePolicyForm: FormGroup;
	@ViewChild(DataTableDirective, { static: false })
	datatableElement: DataTableDirective;
	dtTrigger: Subject<any> = new Subject();
	dtTrigger1: Subject<any> = new Subject();
	isShow: boolean = false;
	submitted: boolean = false;
	cookieaToken: any;
	dtOptions: any = {};
	finalPendingResponse: any;
	finalCompleteResponse: any;
	responseArray: any;
	completeResponse = [];
	policyId: any = [];
	isShowIncompleteDate: boolean = true;
	isShowIncompleteTxt: boolean = false;
	isShowCompleteDate: boolean = true;
	isShowCompleteTxt: boolean = false;
	masterStorageData: any;
	incompleteStorgaeData: any;
	pageName = "";

	constructor(
		private spinner: NgxSpinnerService,
		private commonService: CommonService,
		private commonVariablesService: CommonVariablesService,
		private storageService: StorageService,
		private datePipe: DatePipe,
		private router: Router,
		private formBuilder: FormBuilder
	) {}
	ngOnInit() {
		/* Added page name for master policy filter fetch */
		this.pageName = window.localStorage.getItem("pageName");
		if (this.pageName == "Policy Configuration") {
			this.masterStorageData = window.localStorage.getItem("masterSearchData");
			this.incompleteStorgaeData = window.localStorage.getItem(
				"incompleteStorgaeData"
			);
		}
		this.dtOptions = {
			dom: "ftipr",
			destroy: true,
			pageLength: 50,
		};
		var temp = new Date();
		temp.setDate(temp.getDate() - 9);
		this.incompletePolicyForm = this.formBuilder.group({
			incompleteFromDate: [temp],
			incompleteToDate: [new Date()],
			incompleteType: ["Inception Date"],
			incompleteTxt: [""],
		});
		this.completePolicyForm = this.formBuilder.group({
			completeFromDate: [temp],
			completeToDate: [new Date()],
			completeType: ["Inception Date"],
			completeTxt: [""],
		});
		if (this.masterStorageData) {
			let dateValue = "";
			if (this.masterStorageData.name == "Inception Date") {
				let date = this.masterStorageData.value.split("[]");
				dateValue = date[1].split(",");
			}
			this.completePolicyForm.patchValue({
				completeType: this.masterStorageData.name,
				completeTxt:
					this.masterStorageData.name == "Inception Date"
						? ""
						: this.masterStorageData.value,
				completeFromDate: new Date(dateValue[0]),
				completeToDate: new Date(dateValue[1]),
			});
		}
		if (this.incompleteStorgaeData) {
			this.incompletePolicyForm.patchValue({
				incompleteType: this.incompleteStorgaeData.name,
				incompleteTxt: this.incompleteStorgaeData.value,
				incompleteFromDate: this.incompleteStorgaeData.startDate,
				incompleteToDate: this.incompleteStorgaeData.endDate,
			});
		}
		this.selectCompleteType();
		this.selectIncompleteType();
		this.spinner.show();
		this.loadCompletePolicyData();
		$(document).ready(function () {
			$("#example").DataTable();
		});

		//on clicking the row
		$("tbody tr").on("click", function () {
			//loop through all td elements in the row
			$(this)
				.find("td")
				.each(function (i) {
					//toggle between adding/removing the 'active' class
					$(this).toggleClass("active");
				});
		});
		this.commonService.idToRoutePolicyConfig = 0;
		/* if (!this.finalPendingResponse) {
			$('#table_pendingStatus').DataTable({
				"destroy": true,
				"paging": false,
			});
		} */
	}
	get f() {
		return this.incompletePolicyForm.controls;
	}
	get completeForm() {
		return this.completePolicyForm.controls;
	}
	/*
	 * Created By : Manasa R
	 * Description : Loads the data in complete DataTable and pending DataTable.
	 *********************************************/
	async loadCompletePolicyData() {
		if (this.commonVariablesService.productId == "") {
			let res = await this.commonService.commonLOBvalues();
			if (res == false) {
				this.router.navigate(["/login"]);
			}
		}
		//let url = this.commonVariablesService.baseURL + 'api/v1/policy/list';
		let url = this.commonVariablesService.baseURL + "api/v1/policy/list2";
		/* let paramData = {
			product_id: this.commonVariablesService.productId, fields: "quote.data.policy_type,quote.data.policy_ref_num,cust_fld_1,quote.data.insured_name,quote.data.insured_branch,quote.data.gc_booking_date,quote.data.renewal_counter,quote.data.gc_policy_start_date,quote.data.gc_policy_end_date,quote.data.producer_branch_name",
			cust_fld_10: "1",
			u_ts__start: '1900-01-01'
		} */
		let data = {};
		if (this.masterStorageData) {
			if (this.masterStorageData.name == "Inception Date") {
				data = {
					// 'quote.data.policy_start_date':this.masterStorageData.value,
					g_quote_policy_start_date: this.masterStorageData.value,
					index: ["idx_g_quote_policy_start_date"],
				};
			} else if (this.masterStorageData.name == "Policy Number") {
				data = {
					// 'cust_fld_1':'%'+this.masterStorageData.value+'%',
					g_cust_fld_1: this.masterStorageData.value,
					index: ["idx_g_cust_fld_1_g_cust_fld_10"],
				};
			} else if (this.masterStorageData.name == "Insured Name") {
				data = {
					// 'quote.data.insured_name':'~%'+this.masterStorageData.value+'%',
					g_quote_insured_name: "%" + this.masterStorageData.value + "%",
					index: ["idx_g_quote_insured_name"],
				};
			} else if (this.masterStorageData.name == "Location") {
				data = {
					// 'quote.data.producer_branch_name': '~%'+this.masterStorageData.value+'%',
					g_quote_producer_branch_name: this.masterStorageData.value,
					index: ["idx_g_quote_producer_branch_name"],
				};
			}
		}
		let incompleteData = {};
		if (this.incompleteStorgaeData) {
			if (this.incompleteStorgaeData.name == "Inception Date") {
				incompleteData = {
					gc_booking_date_start: this.datePipe.transform(
						this.incompleteStorgaeData.startDate,
						"yyyy-MM-dd"
					),
					gc_booking_date_end: this.datePipe.transform(
						this.incompleteStorgaeData.endDate,
						"yyyy-MM-dd"
					),
				};
			} else if (this.incompleteStorgaeData.name == "Policy Number") {
				incompleteData = {
					gc_policy_no: this.incompleteStorgaeData.value,
				};
			} else if (this.incompleteStorgaeData.name == "Insured Name") {
				incompleteData = {
					gc_insured_name: this.incompleteStorgaeData.value,
				};
			} else if (this.incompleteStorgaeData.name == "Location") {
				incompleteData = {
					gc_location: this.incompleteStorgaeData.value,
				};
			}
		}
		//data = data ? data :{'quote.data.policy_start_date':'[]'+this.datePipe.transform(this.completePolicyForm.value.completeFromDate, 'yyyy-MM-dd')+','+this.datePipe.transform(this.completePolicyForm.value.completeToDate, 'yyyy-MM-dd')};
		if (!this.masterStorageData) {
			window.localStorage.setItem("masterSearchData", "");
			//data = {'quote.data.policy_start_date':'[]'+this.datePipe.transform(this.completePolicyForm.value.completeFromDate, 'yyyy-MM-dd')+','+this.datePipe.transform(this.completePolicyForm.value.completeToDate, 'yyyy-MM-dd')};
			data = {
				g_quote_policy_start_date:
					"[]" +
					this.datePipe.transform(
						this.completePolicyForm.value.completeFromDate,
						"yyyy-MM-dd"
					) +
					"," +
					this.datePipe.transform(
						this.completePolicyForm.value.completeToDate,
						"yyyy-MM-dd"
					),
				index: ["idx_g_quote_policy_start_date"],
			};
		}
		if (!this.incompleteStorgaeData) {
			window.localStorage.setItem("incompleteStorgaeData", "");
			incompleteData = {
				gc_booking_date_start: this.datePipe.transform(
					this.incompletePolicyForm.value.incompleteFromDate,
					"yyyy-MM-dd"
				),
				gc_booking_date_end: this.datePipe.transform(
					this.incompletePolicyForm.value.incompleteToDate,
					"yyyy-MM-dd"
				),
			};
		}
		let paramData = {
			"quote.product_id": this.commonVariablesService.productId,
			fields:
				"cust_fld_2,policy_start_date,status,policy_id,cust_fld_3,cust_fld_4,data.group_name,quote.data.policy_type,quote.data.policy_ref_num,cust_fld_1,quote.data.insured_name,quote.data.insured_branch,quote.data.gc_booking_date,quote.data.renewal_counter,quote.data.gc_policy_start_date,quote.data.gc_policy_end_date,quote.data.producer_branch_name,quote.data.sme,quote.data.migrated_policy",
			g_cust_fld_10: "1",
			status: "^0,1",
			u_ts: "[1900-01-01",
			count: 100000,
			...data,
		};
		let response = await this.commonService.httpGetMethod(
			url,
			"",
			true,
			paramData,
			"MasterPolicyComponent"
		);
		if (response.status == 0) {
			for (let count = 0; count < response.data.length; count++) {
				this.completeResponse.push(response.data[count]);
			}
			this.unique(this.completeResponse);
		} else if (response.status != -114) {
			this.commonService.errorsmsg("Unable to load data", "Error");
		}
		this.dtTrigger.next();
		let pendingurl =
			this.commonVariablesService.baseURL + "api/v1/marine_mp_gc_data/fetchall";
		let pendingParamData = {
			...incompleteData,
		};
		let pendingResponse = await this.commonService.httpGetMethod(
			pendingurl,
			"",
			true,
			pendingParamData,
			"MasterPolicyComponent"
		);
		if (pendingResponse.status == 0) {
			let newArray = [];
			newArray = pendingResponse.data;
			if (newArray.length > 0) {
				for (let i = 0; i < newArray.length; i++) {
					if (
						newArray[i].renewal_counter != null &&
						newArray[i].renewal_counter != ""
					)
						newArray[i].renewal_counter = Math.floor(
							newArray[i].renewal_counter
						);
					else newArray[i].renewal_counter = "";
				}
			}
			this.finalPendingResponse = newArray;
		} else if (pendingResponse.status != -114) {
			this.commonService.errorsmsg("Unable to load pending list data", "Error");
		}
		this.dtTrigger1.next();
		setTimeout(() => {
			this.spinner.hide();
		}, 5000);
	}
	async submitIncompletePolicy() {
		if (this.incompletePolicyForm.invalid) {
			this.submitted = true;
			return;
		}
		if (this.commonVariablesService.productId == "") {
			let res = await this.commonService.commonLOBvalues();
			if (res == false) {
				this.router.navigate(["/login"]);
			}
		}

		let data = {};
		let storageData: any = {
			name: this.incompletePolicyForm.value.incompleteType,
			startDate: "",
			endDate: "",
			value: "",
		};
		if (this.incompletePolicyForm.value.incompleteType == "Inception Date") {
			data = {
				gc_booking_date_start: this.datePipe.transform(
					this.incompletePolicyForm.value.incompleteFromDate,
					"yyyy-MM-dd"
				),
				gc_booking_date_end: this.datePipe.transform(
					this.incompletePolicyForm.value.incompleteToDate,
					"yyyy-MM-dd"
				),
			};
			storageData.startDate =
				this.incompletePolicyForm.value.incompleteFromDate;
			storageData.endDate = this.incompletePolicyForm.value.incompleteToDate;
		} else if (
			this.incompletePolicyForm.value.incompleteType == "Policy Number"
		) {
			if (this.incompletePolicyForm.value.incompleteTxt.length < 5) {
				this.commonService.errorsmsg(
					"Policy Number length should be greater than or equal to Five.",
					"Error"
				);
				return;
			}
			data = {
				gc_policy_no: this.incompletePolicyForm.value.incompleteTxt,
			};
			storageData.value = this.incompletePolicyForm.value.incompleteTxt;
		} else if (
			this.incompletePolicyForm.value.incompleteType == "Insured Name"
		) {
			data = {
				gc_insured_name: this.incompletePolicyForm.value.incompleteTxt,
			};
			storageData.value = this.incompletePolicyForm.value.incompleteTxt;
		} else if (this.incompletePolicyForm.value.incompleteType == "Location") {
			data = {
				gc_location: this.incompletePolicyForm.value.incompleteTxt,
			};
			storageData.value = this.incompletePolicyForm.value.incompleteTxt;
		}
		window.localStorage.setItem("incompleteStorgaeData", storageData);
		this.finalPendingResponse = [];
		let table = $("#table_pendingStatus").DataTable();
		table.destroy();

		let pendingurl =
			this.commonVariablesService.baseURL + "api/v1/marine_mp_gc_data/fetchall";
		/* let pendingParamData = {
			gc_booking_date_start:this.datePipe.transform(this.incompletePolicyForm.value.incompleteFromDate, 'yyyy-MM-dd'),
			gc_booking_date_end:this.datePipe.transform(this.incompletePolicyForm.value.incompleteToDate, 'yyyy-MM-dd')
		} */
		let pendingResponse = await this.commonService.httpGetMethod(
			pendingurl,
			"",
			true,
			data,
			"MasterPolicyComponent"
		);
		if (pendingResponse.status == 0) {
			let newArray = [];
			newArray = pendingResponse.data;
			if (newArray.length > 0) {
				for (let i = 0; i < newArray.length; i++) {
					if (
						newArray[i].renewal_counter != null &&
						newArray[i].renewal_counter != ""
					)
						newArray[i].renewal_counter = Math.floor(
							newArray[i].renewal_counter
						);
					else newArray[i].renewal_counter = "";
				}
			}
			this.finalPendingResponse = newArray;
		} else if (pendingResponse.status != -114) {
			this.commonService.errorsmsg("Unable to load pending list data", "Error");
		}
		this.dtTrigger1.next();
	}

	async submitCompletePolicy() {
		if (this.completePolicyForm.invalid) {
			this.submitted = true;
			return;
		}
		if (this.commonVariablesService.productId == "") {
			let res = await this.commonService.commonLOBvalues();
			if (res == false) {
				this.router.navigate(["/login"]);
			}
		}
		this.completeResponse = [];
		let data = {};
		let storageData: any = {
			name: this.completePolicyForm.value.completeType,
			value: "",
		};
		if (this.completePolicyForm.value.completeType == "Inception Date") {
			data = {
				/* gc_booking_date_start:this.datePipe.transform(this.completePolicyForm.value.completeFromDate, 'yyyy-MM-dd'),
				gc_booking_date_end:this.datePipe.transform(this.completePolicyForm.value.completeToDate, 'yyyy-MM-dd') */
				// 'quote.data.policy_start_date':'[]'+this.datePipe.transform(this.completePolicyForm.value.completeFromDate, 'yyyy-MM-dd')+','+this.datePipe.transform(this.completePolicyForm.value.completeToDate, 'yyyy-MM-dd'),
				g_quote_policy_start_date:
					"[]" +
					this.datePipe.transform(
						this.completePolicyForm.value.completeFromDate,
						"yyyy-MM-dd"
					) +
					"," +
					this.datePipe.transform(
						this.completePolicyForm.value.completeToDate,
						"yyyy-MM-dd"
					),
				index: ["idx_g_quote_policy_start_date"],
			};
			storageData.value =
				"[]" +
				this.datePipe.transform(
					this.completePolicyForm.value.completeFromDate,
					"yyyy-MM-dd"
				) +
				"," +
				this.datePipe.transform(
					this.completePolicyForm.value.completeToDate,
					"yyyy-MM-dd"
				);
		} else if (this.completePolicyForm.value.completeType == "Policy Number") {
			if (this.completePolicyForm.value.completeTxt.length < 5) {
				this.commonService.errorsmsg(
					"Policy Number length should be greater than or equal to Five.",
					"Error"
				);
				return;
			}
			data = {
				// 'cust_fld_1':'%'+this.completePolicyForm.value.completeTxt+'%',
				g_cust_fld_1: this.completePolicyForm.value.completeTxt,
				index: ["idx_g_cust_fld_1_g_cust_fld_10"],
			};
			storageData.value = this.completePolicyForm.value.completeTxt;
		} else if (this.completePolicyForm.value.completeType == "Insured Name") {
			data = {
				// 'quote.data.insured_name':'~%'+this.completePolicyForm.value.completeTxt+'%',
				g_quote_insured_name:
					"%" + this.completePolicyForm.value.completeTxt + "%",
				index: ["idx_g_quote_insured_name"],
			};
			storageData.value = this.completePolicyForm.value.completeTxt;
		} else if (this.completePolicyForm.value.completeType == "Location") {
			data = {
				// 'quote.data.producer_branch_name':'~%'+this.completePolicyForm.value.completeTxt+'%',
				g_quote_producer_branch_name: this.completePolicyForm.value.completeTxt,
				index: ["idx_g_quote_producer_branch_name"],
			};
			storageData.value = this.completePolicyForm.value.completeTxt;
		}
		window.localStorage.setItem("masterSearchData", storageData);
		let table = $("#table_completedStatus").DataTable();
		table.destroy();
		let url = this.commonVariablesService.baseURL + "api/v1/policy/list2";
		let paramData = {
			"quote.product_id": this.commonVariablesService.productId,
			fields:
				"cust_fld_2,policy_start_date,status,policy_id,cust_fld_3,cust_fld_4,data.group_name,quote.data.policy_type,quote.data.policy_ref_num,cust_fld_1,quote.data.insured_name,quote.data.insured_branch,quote.data.gc_booking_date,quote.data.renewal_counter,quote.data.gc_policy_start_date,quote.data.gc_policy_end_date,quote.data.producer_branch_name,quote.data.sme,quote.data.migrated_policy",
			g_cust_fld_10: "1",
			u_ts: "[1900-01-01",
			status: "^0,1",
			count: 100000,
			...data,
		};
		let response = await this.commonService.httpGetMethod(
			url,
			"",
			true,
			paramData,
			"MasterPolicyComponent"
		);
		if (response.status == 0) {
			for (let count = 0; count < response.data.length; count++) {
				this.completeResponse.push(response.data[count]);
			}
			this.unique(this.completeResponse);
		} else if (response.status != -114) {
			this.commonService.errorsmsg("Unable to load data", "Error");
		}
		this.dtTrigger.next();
	}
	/*
	 * Created By : Manasa R
	 * Description : It will filter and give unique policy number with in object.
	 *********************************************/
	unique(obj) {
		let newArray = [];
		for (let i = 0; i < obj.length; i++) {
			if (newArray.length == 0) {
				newArray.push(obj[i]);
			} else {
				let count = 0;
				for (let j = 0; j < newArray.length; j++) {
					if (obj[i].cust_fld_3 == newArray[j].cust_fld_3) count++;
				}
				if (count == 0) newArray.push(obj[i]);
			}
		}
		/* let newArray = [];
		let uniqueObject = {};
		for (let i in obj) {
			let objTitle = obj[i].cust_fld_3;
			//if(obj[i].status == 0)
				uniqueObject[objTitle] = obj[i];
		}
		for (let i in uniqueObject) {
			newArray.push(uniqueObject[i]);
		} */
		if (newArray.length > 0) {
			for (let i = 0; i < newArray.length; i++) {
				if (
					newArray[i].quote.data.renewal_counter != null &&
					newArray[i].quote.data.renewal_counter != ""
				)
					newArray[i].quote.data.renewal_counter = Math.floor(
						newArray[i].quote.data.renewal_counter
					);
				else newArray[i].quote.data.renewal_counter = "";
			}
		}
		this.finalCompleteResponse = newArray;
	}

	/*
	 * Created By : Manasa R
	 * Description : Its filters the complete list table data at the time of search.
	 *********************************************/
	filterById(): void {
		let businessType = $("#txt_businessType").val().toString().toLowerCase();
		let policyNo = $("#txt_policyno").val().toString().toLowerCase();
		let inceptionDate = $("#txt_incepectiondate")
			.val()
			.toString()
			.toLowerCase();
		let insuredName = $("#txt_insuredName").val().toString().toLowerCase();
		let officeBranch = $("#txt_office").val().toString().toLowerCase();
		let renewalCounter = $("#txt_renewalcounter")
			.val()
			.toString()
			.toLowerCase();
		let bookingDate = $("#txt_bookingDate").val().toString().toLowerCase();
		let setupStatus = $("#txt_setupStatus").val().toString().toLowerCase();
		let policyStatus = $("#txt_policyStatus").val().toString().toLowerCase();
		let Group = $("#txt_Group").val().toString().toLowerCase();
		let sme = $("#txt_sme").val().toString().toLowerCase();
		let migratedPolicy = $("#txt_migratedPolicy")
		.val()
		.toString()
		.toLowerCase();
		var table = $("#table_completedStatus").DataTable();
		table.search("").columns().search("").draw();
		if (businessType != "") {
			table.column(1).search(businessType).draw();
		}
		if (policyNo != "") {
			table.column(2).search(policyNo).draw();
		}
		if (inceptionDate != "") {
			table.column(3).search(inceptionDate).draw();
		}
		if (insuredName != "") {
			table.column(4).search(insuredName).draw();
		}
		if (officeBranch != "") {
			table.column(5).search(officeBranch).draw();
		}
		if (renewalCounter != "") {
			table.column(6).search(renewalCounter).draw();
		}
		if (bookingDate != "") {
			table.column(7).search(bookingDate).draw();
		}
		if (setupStatus != "") {
			table.column(8).search(setupStatus).draw();
		}
		if (policyStatus != "") {
			table.column(9).search(policyStatus).draw();
		}
		if (Group != "") {
			table.column(10).search(Group).draw();
		}
		if (sme != "") {
			table.column(11).search(sme).draw();
		}
		if (migratedPolicy != "") {
			table.column(12).search(migratedPolicy).draw();}
	}

	/*
	 * Created By : Manasa R
	 * Description : Its filters the pending list table data at the time of search .
	 *********************************************/
	filterByIdPendingStatus(element): void {
		let businessType = $("#txt_pendingBusinessType")
			.val()
			.toString()
			.toLowerCase();
		let policyNo = $("#txt_pendingPolicyno").val().toString().toLowerCase();
		let inceptionDate = $("#txt_pendingIncepectiondate")
			.val()
			.toString()
			.toLowerCase();
		let insuredName = $("#txt_pendingInsuredName")
			.val()
			.toString()
			.toLowerCase();
		let officeBranch = $("#txt_pendingOffice").val().toString().toLowerCase();
		let renewalCounter = $("#txt_pendingRenewalcounter")
			.val()
			.toString()
			.toLowerCase();
		let bookingDate = $("#txt_pendingBookingDate")
			.val()
			.toString()
			.toLowerCase();
		let setupStatus = $("#txt_pendingSetupStatus")
			.val()
			.toString()
			.toLowerCase();
		let policyStatus = $("#txt_pendingPolicyStatus")
			.val()
			.toString()
			.toLowerCase();
		let Group = $("#txt_pendingGroup").val().toString().toLowerCase();
		let sme = $("#txt_pendingSme").val().toString().toLowerCase();
		let migratedPolicy = $("#txt_pendingMigratedPolicy")
		.val()
		.toString()
		.toLowerCase();
		let table = $("#table_pendingStatus").DataTable();
		table.search("").columns().search("").draw();
		if (businessType != "") {
			table.column(1).search(businessType).draw();
		}
		if (policyNo != "") {
			table.column(2).search(policyNo).draw();
		}
		if (inceptionDate != "") {
			table.column(3).search(inceptionDate).draw();
		}
		if (insuredName != "") {
			table.column(4).search(insuredName).draw();
		}
		if (officeBranch != "") {
			table.column(5).search(officeBranch).draw();
		}
		if (renewalCounter != "") {
			table.column(6).search(renewalCounter).draw();
		}
		if (bookingDate != "") {
			table.column(7).search(bookingDate).draw();
		}
		if (setupStatus != "") {
			table.column(8).search(setupStatus).draw();
		}
		if (policyStatus != "") {
			table.column(9).search(policyStatus).draw();
		}
		if (Group != "") {
			table.column(10).search(Group).draw();
		}
		if (sme != "") {
			table.column(11).search(sme).draw();
		}
		if (migratedPolicy != "") {
			table.column(12).search(migratedPolicy).draw();
	}
	
	}

	/*
	 * Created By : Manasa R
	 * Description : It will route to policy config producer tab.
	 *********************************************/
	movingToPolicyConfigProducer(policyRefNumber, respStatus, status) {
		let count = 0,
			statusCount = 0;
		for (let i = 0; i < this.completeResponse.length; i++) {
			if (this.completeResponse[i].cust_fld_3 == policyRefNumber) {
				count++;
				if (this.completeResponse[i].status == 1) statusCount++;
			}
		}
		if (count == statusCount) {
			//this.commonService.warningmsg("Policy already cancelled cannot be edited","worning");
			/* this.cookie.set('status', 'Cancelled');  */
			window.localStorage.setItem("status", "Cancelled");
		} else window.localStorage.setItem("status", "");
		/* else this.cookie.set('status', '') */
		let referenceNumber = "";
		if (status == 0) {
			/* for (let i = 0; i < this.completeResponse.length; i++) {
				if (this.completeResponse[i].cust_fld_3 ==policyRefNumber && this.completeResponse[i].status == 0) {
					
						this.policyId.push(this.completeResponse[i].policy_id);
					referenceNumber= this.completeResponse[i].cust_fld_3;
				}
			} */
			if (window.localStorage.getItem("status") != "Cancelled") {
				for (let i = 0; i < this.completeResponse.length; i++) {
					if (
						this.completeResponse[i].cust_fld_3 == policyRefNumber &&
						this.completeResponse[i].status == 0
					) {
						referenceNumber = this.completeResponse[i].cust_fld_3;
						this.policyId.push(this.completeResponse[i].policy_id);
					}
				}
			} else if (window.localStorage.getItem("status") == "Cancelled") {
				for (let i = 0; i < this.completeResponse.length; i++) {
					if (this.completeResponse[i].cust_fld_3 == policyRefNumber) {
						referenceNumber = this.completeResponse[i].cust_fld_3;
						this.policyId.push(this.completeResponse[i].policy_id);
					}
				}
			}
			//id=data;
			/* this.cookie.set('policyId', this.policyId);
			this.cookie.set('referenceNumber', referenceNumber); */
			window.localStorage.setItem("policyId", this.policyId);
			window.localStorage.setItem("referenceNumber", referenceNumber);
			this.commonService.idToRoutePolicyConfig = 2;
			this.router.navigate(["/policy-configuration/0/0"]);
		} else {
			this.commonService.idToRoutePolicyConfig = 2;
			this.router.navigate(["/policy-configuration", policyRefNumber, status]);
		}
	}

	/*
	 * Created By : Manasa R
	 * Description : It will route to policy config.
	 *********************************************/
	movingToPolicyConfig(policyrefnumber, status) {
		this.router.navigate(["/policy-configuration", policyrefnumber, status]);
		this.commonService.idToRoutePolicyConfig = 3;
	}

	/*
	 * Created By : Manasa R
	 * Description : It will route to policy config client tab.
	 *********************************************/
	movingToPolicyConfigClient(policyRefNumber, respStatus, status) {
		let count = 0,
			statusCount = 0;
		for (let i = 0; i < this.completeResponse.length; i++) {
			if (this.completeResponse[i].cust_fld_3 == policyRefNumber) {
				count++;
				if (this.completeResponse[i].status == 1) statusCount++;
			}
		}
		if (count == statusCount) {
			//this.commonService.warningmsg("Policy already cancelled cannot be edited","worning");
			/* this.cookie.set('status', 'Cancelled'); } */
			window.localStorage.setItem("status", "Cancelled");
		} else window.localStorage.setItem("status", "");
		/* else this.cookie.set('status', '') */
		let referenceNumber = "";
		if (status == 0) {
			/* for (let i = 0; i < this.completeResponse.length; i++) {
				if (this.completeResponse[i].cust_fld_3 == policyRefNumber) {
					
						this.policyId.push(this.completeResponse[i].policy_id && this.completeResponse[i].status == 0);
					referenceNumber= this.completeResponse[i].cust_fld_3;
				}
			} */
			if (window.localStorage.getItem("status") != "Cancelled") {
				for (let i = 0; i < this.completeResponse.length; i++) {
					if (
						this.completeResponse[i].cust_fld_3 == policyRefNumber &&
						this.completeResponse[i].status == 0
					) {
						referenceNumber = this.completeResponse[i].cust_fld_3;
						this.policyId.push(this.completeResponse[i].policy_id);
					}
				}
			} else if (window.localStorage.getItem("status") == "Cancelled") {
				for (let i = 0; i < this.completeResponse.length; i++) {
					if (this.completeResponse[i].cust_fld_3 == policyRefNumber) {
						referenceNumber = this.completeResponse[i].cust_fld_3;
						this.policyId.push(this.completeResponse[i].policy_id);
					}
				}
			}
			//id=data;
			/* this.cookie.set('policyId', this.policyId);
			this.cookie.set('referenceNumber', referenceNumber); */
			window.localStorage.setItem("policyId", this.policyId);
			window.localStorage.setItem("referenceNumber", referenceNumber);
			this.commonService.idToRoutePolicyConfig = 1;
			this.router.navigate(["/policy-configuration/0/0"]);
		} else {
			this.spinner.hide();
			this.commonService.idToRoutePolicyConfig = 1;
			this.router.navigate(["/policy-configuration", policyRefNumber, status]);
		}
	}

	/*
	 * Created By : Manasa R
	 * Description : It will route to policy config at the time of complete status.
	 *********************************************/
	routingToPolicyForCompleteStatus(policyData) {
		let count = 0,
			statusCount = 0;
		for (let i = 0; i < this.completeResponse.length; i++) {
			if (this.completeResponse[i].cust_fld_3 == policyData.cust_fld_3) {
				count++;
				if (this.completeResponse[i].status == 1) statusCount++;
			}
		}
		if (count == statusCount) {
			window.localStorage.setItem("status", "Cancelled");
		} else window.localStorage.setItem("status", "");
		let id;
		let referenceNumber = "";
		window.localStorage.setItem("policyId", "");
		this.storageService.policyId = [];
		/* if (status == 0) { */
		if (window.localStorage.getItem("status") != "Cancelled") {
			for (let i = 0; i < this.completeResponse.length; i++) {
				if (
					this.completeResponse[i].cust_fld_3 == policyData.cust_fld_3 &&
					this.completeResponse[i].status == 0
				) {
					referenceNumber = this.completeResponse[i].cust_fld_3;
					this.policyId.push(this.completeResponse[i].policy_id);
				}
			}
		} else if (window.localStorage.getItem("status") == "Cancelled") {
			for (let i = 0; i < this.completeResponse.length; i++) {
				if (this.completeResponse[i].cust_fld_3 == policyData.cust_fld_3) {
					referenceNumber = this.completeResponse[i].cust_fld_3;
					this.policyId.push(this.completeResponse[i].policy_id);
				}
			}
		}
		//id=data;
		this.router.navigate(["/policy-configuration/0/0"]);
		// 	queryParams: { data: id }
		//   }]);
		/* this.cookie.set('policyId', this.policyId);
		this.cookie.set('referenceNumber', referenceNumber); */
		window.localStorage.setItem("policyId", this.policyId);
		window.localStorage.setItem("referenceNumber", referenceNumber);
		/* } */
	}
	movingToAuditTrail(policyrefno, status, policyno) {
		if (status == 0) {
			// let referenceNumber = "";
			/* this.cookie.set('policyId', ''); */
			window.localStorage.setItem("policyId", "");
			for (let i = 0; i < this.completeResponse.length; i++) {
				if (this.completeResponse[i].cust_fld_3 == policyrefno) {
					// referenceNumber = this.completeResponse[i].cust_fld_3;
					this.policyId.push(this.completeResponse[i].policy_id);
				}
			}

			/* this.cookie.set('policyId', this.policyId);
			this.cookie.set('referenceNumber', policyrefno);
			this.cookie.set('policyNumberForAuditTrail', policyno); */
			window.localStorage.setItem("policyId", this.policyId);
			window.localStorage.setItem("referenceNumber", policyrefno);
			window.localStorage.setItem("policyNumberForAuditTrail", policyno);
		}
		this.router.navigate(["/audit-trail"]);
		/* this.cookie.set('referenceNumber', policyrefno);
		this.cookie.set('policyNumberForAuditTrail', policyno);
		this.cookie.set('policyStatus', status); */
		window.localStorage.setItem("referenceNumber", policyrefno);
		window.localStorage.setItem("policyNumberForAuditTrail", policyno);
		window.localStorage.setItem("policyStatus", status);
	}
	/*
	* Created By : Manasa R
	* Description : It will check the start date and end date with system date and return active
	                or inactive status with in complete DataTable.
	*********************************************/
	/* checkForActiveStatus(startDate, endDate, policyStatus) {
		let formattedstartDate = new Date(startDate);
		let formatedendDate = new Date(endDate);
		/* let systemDate = this.datePipe.transform(this.cookie.get("systemTime"), 'yyyy-MM-dd'); */
	/* let systemDate = this.datePipe.transform(window.localStorage.getItem("systemTime"), 'yyyy-MM-dd');
	let formatedsystemDate = new Date(systemDate);

	if (policyStatus == 'APC' || policyStatus == 'APU' || policyStatus == 'APD' || policyStatus == 'ECDU'
		|| policyStatus == 'ERFC' || policyStatus == 'ACDE' || policyStatus == 'EPCE' || policyStatus == 'ERAPH'
		|| policyStatus == 'ACDC' || policyStatus == 'EPR')
		return false;

	if (formattedstartDate <= formatedsystemDate && formatedendDate >= formatedsystemDate)
		return true;
	else
		return false;
}  */
	/* checkForActiveStatus(startDate, endDate) {
		let formattedstartDate = new Date(startDate);
		let formatedendDate = new Date(endDate);
		/* let systemDate = this.datePipe.transform(this.cookie.get("systemTime"), 'yyyy-MM-dd'); /
		let systemDate = this.datePipe.transform(window.localStorage.getItem("systemTime"), 'yyyy-MM-dd');
		let formatedsystemDate = new Date(systemDate);
		if (formattedstartDate <= formatedsystemDate && formatedendDate >= formatedsystemDate)
			return true;
		else
			return false;

	} */
	checkForActiveStatus(startDate, endDate, policyStatus, modifyEndDate) {
		let formattedstartDate = new Date(startDate);
		let formatedendDate = modifyEndDate
			? new Date(modifyEndDate)
			: new Date(endDate);
		/* let systemDate = this.datePipe.transform(this.cookie.get("systemTime"), 'yyyy-MM-dd'); */
		let systemDate = this.datePipe.transform(
			window.localStorage.getItem("systemTime"),
			"yyyy-MM-dd"
		);
		let formatedsystemDate = new Date(systemDate);

		if (
			policyStatus == "APC" ||
			policyStatus == "APU" ||
			policyStatus == "APD" ||
			policyStatus == "ECDU" ||
			policyStatus == "ERFC" ||
			policyStatus == "ACDE" ||
			policyStatus == "EPCE" ||
			policyStatus == "ERAPH" ||
			policyStatus == "ACDC" ||
			policyStatus == "EPR"
		)
			return "Cancelled";

		if (
			formattedstartDate <= formatedsystemDate &&
			formatedendDate >= formatedsystemDate
		)
			return "Active";
		else return "InActive";
	}
	selectIncompleteType() {
		if (this.incompletePolicyForm.value.incompleteType != "Inception Date") {
			this.isShowIncompleteTxt = true;
			this.isShowIncompleteDate = false;
			this.incompletePolicyForm
				.get("incompleteTxt")
				.setValidators([Validators.required]);
			this.incompletePolicyForm.get("incompleteFromDate").clearValidators();
			this.incompletePolicyForm.get("incompleteToDate").clearValidators();
			this.incompletePolicyForm.patchValue({
				incompleteTxt: "",
			});
		} else {
			this.isShowIncompleteTxt = false;
			this.isShowIncompleteDate = true;
			this.incompletePolicyForm.get("incompleteTxt").clearValidators();
			this.incompletePolicyForm
				.get("incompleteFromDate")
				.setValidators([Validators.required]);
			this.incompletePolicyForm
				.get("incompleteToDate")
				.setValidators([Validators.required]);
		}
		this.incompletePolicyForm.get("incompleteTxt").updateValueAndValidity();
		this.incompletePolicyForm
			.get("incompleteFromDate")
			.updateValueAndValidity();
		this.incompletePolicyForm.get("incompleteToDate").updateValueAndValidity();
	}
	selectCompleteType() {
		if (this.completePolicyForm.value.completeType != "Inception Date") {
			this.isShowCompleteTxt = true;
			this.isShowCompleteDate = false;
			this.completePolicyForm
				.get("completeTxt")
				.setValidators([Validators.required]);
			this.completePolicyForm.get("completeFromDate").clearValidators();
			this.completePolicyForm.get("completeToDate").clearValidators();
			this.completePolicyForm.patchValue({
				completeTxt: "",
			});
		} else {
			this.isShowCompleteTxt = false;
			this.isShowCompleteDate = true;
			this.completePolicyForm.get("completeTxt").clearValidators();
			this.completePolicyForm
				.get("completeFromDate")
				.setValidators([Validators.required]);
			this.completePolicyForm
				.get("completeToDate")
				.setValidators([Validators.required]);
		}
		this.completePolicyForm.get("completeTxt").updateValueAndValidity();
		this.completePolicyForm.get("completeFromDate").updateValueAndValidity();
		this.completePolicyForm.get("completeToDate").updateValueAndValidity();
	}
}
